// extracted by mini-css-extract-plugin
export default {"root":"NotificacaoTitle_root__trgMQ","title":"NotificacaoTitle_title__W4YVE"};